import Box from "@mui/material/Box";
import AttachmentCard from "./Card";

function AttachmentContent({
  value,
  removeAttachment,
  setMandatory,
  canBeMandatory = false,
  ...rest
}) {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "5px" }}>
      {typeof value != "string" &&
        value?.length > 0 &&
        value
          .map((attachment, index) => {
            if (attachment?.condition !== "removed") {
              return (
                <AttachmentCard
                  {...rest}
                  key={`file-${attachment.resourceId}`}
                  attachment={attachment}
                  index={index}
                  removeAttachment={removeAttachment}
                  setMandatory={(value) => setMandatory(index, value)}
                  mandatory={attachment.mandatory}
                />
              );
            }

            return null;
          })
          .filter((child) => child != null)}
    </Box>
  );
}

export default AttachmentContent;
